import { render } from "./CareerMain.vue?vue&type=template&id=3b0d7ceb"
import script from "./CareerMain.vue?vue&type=script&lang=js"
export * from "./CareerMain.vue?vue&type=script&lang=js"

import "./CareerMain.vue?vue&type=style&index=0&id=3b0d7ceb&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__